import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function initEnvironment() {
    return dispatch => {
        return apiCaller
            .call(api.initEnvironment())
            .then(({ data }) => {
                if (data.supportUsers) {
                    dispatch({
                        type: 'LOGGING__SET_SUPPORT_USERS',
                        supportUsers: data.supportUsers
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';

                return data;
            })
            .catch(error => {
                Logger.error('dataActions: initEnvironmentLogging - ', error);
                throw error;
            });
    };
}

export { initEnvironment };



// WEBPACK FOOTER //
// ./environments/logging/actions.js